const data: any = [{"key":"forgot-devices","copy":"Successfully Forgot your Devices."}];
export default data